import axios from 'axios';
import { localizationFeatureFlag } from '../constants';

interface IFeatureFlagResponse {
  LockIndex: number;
  Key: string;
  Flags: number;
  Value: string;
  CreateIndex: number;
  ModifyIndex: number;
}

const fetchFeatureFlags = async (): Promise<IFeatureFlagResponse[] | null> => {
  try {
    const response = await axios.get<IFeatureFlagResponse[]>('/spapi/featureFlags');
    return response.data;
  } catch (e) {
    return null;
  }
};

export const isI18nFeatureEnabled = async () => {
  const featureFlags = await fetchFeatureFlags();
  if (featureFlags?.length) {
    const i18nFeatureFlag = featureFlags.find(item => item.Key === `FeatureManagement:${localizationFeatureFlag}`);
    if (i18nFeatureFlag?.Value === 'dHJ1ZQ==') return true;
  }

  return false;
};

export const isExtendedLocalesEnabled = async () => {
  const featureFlags = await fetchFeatureFlags();
  if (featureFlags?.length) {
    const i18nFeatureFlag = featureFlags.find(item => item.Key === `FeatureManagement:EnableExtendedLocales`);
    if (i18nFeatureFlag?.Value === 'dHJ1ZQ==') return true;
  }

  return false;
};
